import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import {
  composeMapper,
  getSocialCompBlockingLayerProps,
} from '@wix/editor-elements-preview-utils';
import type { PreviewWrapperProps } from '@wix/editor-elements-types/thunderboltPreview';
import {
  PinterestPinItDefinition,
  PinterestPinItMapperProps,
} from '../PinterestPinIt.types';
import { props as viewerPropsMapper } from './PinterestPinIt.mapper';

const props = composeMapper<
  PreviewWrapperProps<PinterestPinItMapperProps>,
  PinterestPinItDefinition
>()(
  viewerPropsMapper,
  {
    add: ['isSocialInteractionAllowed'],
  },
  (resolver, dependencies, carmiData) => {
    const viewerProps = resolver(dependencies, carmiData);
    const { isSocialInteractionAllowed } = dependencies;
    return {
      ...viewerProps,
      previewWrapperProps: getSocialCompBlockingLayerProps(
        isSocialInteractionAllowed,
      ),
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
